// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'semantic-ui-react';
// local
// actions
import { closeModal } from 'app/redux/actions/confirmDelivery/confirmModal';

class ConfirmSendModal extends Component {
    state = { patientQtd: 0, cylindersPending: 0, cylindersDelivered: 0 };

    onClose = () => this.props.dispatch(closeModal());

    componentWillUnmount = () => this.onClose();

    onClickConfirm = () => {
        this.onClose();
        const { onClickConfirm } = this.props;
        if (onClickConfirm) {
            onClickConfirm(this.props.modalConfirmSend.data);
        }
    };

    componentWillReceiveProps(nextProps) {
        const data = nextProps.modalConfirmSend.data;
        if (data) {
            const patientsSet = new Set();
            let cylindersDelivered = 0;
            let cylindersPending = 0;
            data.forEach(r => {
                patientsSet.add(r.patient.id);
                cylindersDelivered += r.counter;
                cylindersPending += r.cylinderQtdRequested - r.counter;
            });
            this.setState({
                cylindersDelivered,
                cylindersPending,
                patientQtd: patientsSet.size,
            });
        }
    }

    render() {
        const { isOpened } = this.props.modalConfirmSend;
        const { patientQtd, cylindersDelivered, cylindersPending } = this.state;
        return (
            <Modal open={isOpened} onClose={this.onClose}>
                <Modal.Content>
                    <p className="content text-center">
                        Foi feita a confirmação de entrega de <span className="bold">{patientQtd} paciente(s)</span>, totalizando{' '}
                        <span className="bold">{cylindersDelivered}</span> cilindro(s) ENTREGUES e <span className="bold">{cylindersPending}</span> cilindro(s)
                        PENDENTES. Você deseja prosseguir com as confirmação(ões)?
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.onClose}>Cancelar</Button>
                    <Button onClick={this.onClickConfirm} className="highlight">
                        Confirmar
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

ConfirmSendModal.propTypes = {
    modalConfirmSend: PropTypes.object,
    onClickConfirm: PropTypes.func,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    modalConfirmSend: state.modalConfirmSend,
});
export default connect(mapStateToProps)(ConfirmSendModal);
